/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Chip,
  Divider,
  Drawer,
  Hidden,
  Link,
  List,
  ListSubheader,
  Typography,
  TextField,
  makeStyles,
  MenuItem
} from '@material-ui/core';
import {
  // Briefcase as BriefcaseIcon,
  // Calendar as CalendarIcon,
  // Folder as FolderIcon,
  // BarChart as BarChartIcon,
  // Lock as LockIcon,
  // UserPlus as UserPlusIcon,
  // AlertCircle as AlertCircleIcon,
  // Trello as TrelloIcon,
  // User as UserIcon,
  // Layout as LayoutIcon,
  // Edit as EditIcon,
  // DollarSign as DollarSignIcon,
  // Mail as MailIcon,
  // MessageCircle as MessageCircleIcon,
  // PieChart as PieChartIcon,
  // Share2 as ShareIcon,
  Users as UsersIcon
} from 'react-feather';
import BusinessIcon from '@material-ui/icons/Business';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ViewListIcon from '@material-ui/icons/ViewList';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import StoreIcon from '@material-ui/icons/Store';
import Logo from 'src/components/Logo';
import useAuth from 'src/hooks/useAuth';
import NavItem from './NavItem';
import Autocomplete from '@material-ui/lab/Autocomplete';

import ComputerIcon from '@material-ui/icons/Computer';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CallReceivedIcon from '@material-ui/icons/CallReceived';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import SendIcon from '@material-ui/icons/Send';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import FlightLandIcon from '@material-ui/icons/FlightLand';
import TrendingDownIcon from '@material-ui/icons/TrendingDown';
import AssessmentIcon from '@material-ui/icons/Assessment';
import FitnessCenterIcon from '@material-ui/icons//FitnessCenter';

import { useDispatch } from 'src/store';
import { setBranch } from 'src/slices/branch';

const sections = [
  // {
  //   subheader: 'Reports',
  //   items: [
  //     {
  //       title: 'Dashboard',
  //       icon: PieChartIcon,
  //       href: '/app/reports/dashboard'
  //     },
  //     {
  //       title: 'Dashboard Alternative',
  //       icon: BarChartIcon,
  //       href: '/app/reports/dashboard-alternative'
  //     }
  //   ]
  // },
  {
    subheader: 'POS',
    items: [
      {
        title: 'Point of Sale',
        icon: StoreIcon,
        href: '/app/pos',
        items: [
          {
            title: '48h Weighbridge.',
            icon: ViewListIcon,
            href: '/app/pos/weighbridge'
          },
          {
            title: 'Weighbridge Note',
            icon: FitnessCenterIcon,
            href: '/app/pos/weighbridge/new'
          },
          {
            title: 'List Current Purchases',
            icon: ViewListIcon,
            href: '/app/pos/purchases'
          },
          {
            title: 'Purchase',
            icon: ShoppingCartIcon,
            href: '/app/pos/purchases/new'
          },
          {
            title: 'List Current Sales',
            icon: ViewListIcon,
            href: '/app/pos/sales'
          },
          {
            title: 'Sale',
            icon: ReceiptIcon,
            href: '/app/pos/sales/new'
          },
          {
            title: 'Issue Loan',
            icon: ChevronRightIcon,
            href: '/app/pos/loan/new'
          },
          {
            title: 'Settle Loan',
            icon: ChevronRightIcon,
            href: '/app/pos/loan/settleloan'
          },
          {
            title: 'Float Expenses',
            icon: TrendingDownIcon,
            href: '/app/pos/float/expense'
          },
          {
            title: 'Float Issued',
            icon: FlightTakeoffIcon,
            href: '/app/pos/float/issued'
          },
          {
            title: 'Float Received',
            icon: FlightLandIcon,
            href: '/app/pos/float/received'
          },
          {
            title: 'Float',
            icon: AutorenewIcon,
            href: '/app/pos/float/continue'
          },
          {
            title: 'Cashup',
            icon: CheckCircleOutlineIcon,
            href: '/app/pos/float/cashup'
          },
          {
            title: 'New Float',
            icon: AddCircleOutlineIcon,
            href: '/app/pos/float/new'
          }
        ]
      },
      {
        title: 'POS Management',
        icon: StoreIcon,
        href: '/app/pos',
        items: [
          {
            title: 'List All Weighbridge',
            icon: ViewListIcon,
            href: '/app/pos/allweighbridge'
          },
          {
            title: 'List All Purchases',
            icon: ViewListIcon,
            href: '/app/pos/allpurchases'
          },
          {
            title: 'List All Sales',
            icon: ViewListIcon,
            href: '/app/pos/allsales'
          },
          {
            title: 'List All Expenses',
            icon: ViewListIcon,
            href: '/app/pos/allexpenses'
          },
          {
            title: 'List All Loans',
            icon: ViewListIcon,
            href: '/app/pos/allloans/'
          },
          {
            title: 'List All Cashups',
            icon: ViewListIcon,
            href: '/app/management/cashup-reports'
          },
          {
            title: 'List Current Float',
            icon: ViewListIcon,
            href: '/app/pos/float/list'
          },
          {
            title: 'Create a Cash Register',
            icon: ImportantDevicesIcon,
            href: '/app/pos/cashregister/new'
          }
        ]
      }
    ]
  },
  {
    subheader: 'Reports',
    items: [
      {
        title: 'Reports',
        icon: AssessmentIcon,
        href: '/app/reports',
        items: [
          {
            title: 'Purchases',
            icon: ViewListIcon,
            href: '/app/reports/purchase-per-transaction'
          },
          {
            title: 'Sales',
            icon: ViewListIcon,
            href: '/app/reports/sale-per-transaction'
          },
          {
            title: 'Trade Summary',
            icon: ViewListIcon,
            href: '/app/reports/stock-per-transaction/pdf'
          },
          {
            title: 'Floats',
            icon: ViewListIcon,
            href: '/app/reports/float-per-transaction'
          },
          {
            title: 'Cashups',
            icon: ViewListIcon,
            href: '/app/reports/cashup-reports'
          },
          {
            title: 'Weighbridges',
            icon: ViewListIcon,
            href: '/app/reports/weighbridge-per-transaction'
          },
          {
            title: 'Customers',
            icon: ViewListIcon,
            href: '/app/reports/customer-report'
          },
          {
            title: 'Products',
            icon: ViewListIcon,
            href: '/app/reports/product-summary'
          }
        ]
      }
      // {
      //   title: 'PDF Reports',
      //   icon: AssessmentIcon,
      //   href: '/app/reports/pdf',
      //   items: [
      //     {
      //       title: 'Trade Summary',
      //       icon: ViewListIcon,
      //       href: '/app/reports/stock-per-transaction/pdf'
      //     },
      //   ]
      // }
    ]
  },
  {
    subheader: 'Management',
    items: [
      {
        title: 'Customers',
        icon: UsersIcon,
        href: '/app/management/customers',
        items: [
          {
            title: 'List Customers',
            href: '/app/management/customers'
          },
          {
            title: 'New Customer',
            href: '/app/management/customers/new'
          }
          // {
          //   title: 'Edit Customer',
          //   href: '/app/management/customers/1/edit'
          // }
        ]
      },
      {
        title: 'Branches',
        icon: BusinessIcon,
        href: '/app/management/branches',
        items: [
          {
            title: 'List Branches',
            href: '/app/management/branches'
          }
          // {
          //   title: 'New Customer',
          //   href: '/app/management/branches/new'
          // },
          // {
          //   title: 'Edit Branch',
          //   href: '/app/management/customers/1/edit'
          // }
        ]
      },
      {
        title: 'Products',
        icon: ShoppingCartIcon,
        href: '/app/management/products',
        items: [
          {
            title: 'List Products',
            href: '/app/management/products'
          },
          {
            title: 'New Product',
            href: '/app/management/products/create'
          },
          {
            title: 'Categories',
            href: '/app/management/categories/create'
          }
        ]
      },
      // {
      //   title: 'Orders',
      //   icon: FolderIcon,
      //   href: '/app/management/orders',
      //   items: [
      //     {
      //       title: 'List Orders',
      //       href: '/app/management/orders'
      //     },
      //     {
      //       title: 'View Order',
      //       href: '/app/management/orders/1'
      //     }
      //   ]
      // },
      // {
      //   title: 'Invoices',
      //   icon: ReceiptIcon,
      //   href: '/app/management/invoices',
      //   items: [
      //     {
      //       title: 'List Invoices',
      //       href: '/app/management/invoices'
      //     },
      //     {
      //       title: 'View Invoice',
      //       href: '/app/management/invoices/1'
      //     }
      //   ]
      // },
      // {
      //   title: 'Cashup Reports',
      //   icon: ReceiptIcon,
      //   href: '/app/management/cashup-reports',
      //   items: [
      //     {
      //       title: 'List All Cashup Reports',
      //       href: '/app/management/cashup-reports'
      //     },
      //     {
      //       title: 'View Cashup Report',
      //       href: '/app/management/cashup-reports/1'
      //     }
      //   ]
      // }
      // {
      //   title: 'Purchases',
      //   icon: ReceiptIcon,
      //   href: '/app/management/purchaseNotes',
      //   items: [
      //     {
      //       title: 'List Purchases',
      //       href: '/app/management/purchaseNote'
      //     },
      //     {
      //       title: 'View Purchases',
      //       href: '/app/management/purchaseNote/1'
      //     }
      //   ]
      // }
    ]
  },
  // {
  //   subheader: 'Applications',
  //   items: [
  //     {
  //       title: 'Projects Platform',
  //       href: '/app/projects',
  //       icon: BriefcaseIcon,
  //       items: [
  //         {
  //           title: 'Overview',
  //           href: '/app/projects/overview'
  //         },
  //         {
  //           title: 'Browse Projects',
  //           href: '/app/projects/browse'
  //         },
  //         {
  //           title: 'Create Project',
  //           href: '/app/projects/create'
  //         },
  //         {
  //           title: 'View Project',
  //           href: '/app/projects/1'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Social Platform',
  //       href: '/app/social',
  //       icon: ShareIcon,
  //       items: [
  //         {
  //           title: 'Profile',
  //           href: '/app/social/profile'
  //         },
  //         {
  //           title: 'Feed',
  //           href: '/app/social/feed'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Kanban',
  //       href: '/app/kanban',
  //       icon: TrelloIcon
  //     },
  //     {
  //       title: 'Mail',
  //       href: '/app/mail',
  //       icon: MailIcon
  //     },
  //     {
  //       title: 'Chat',
  //       href: '/app/chat',
  //       icon: MessageCircleIcon,
  //       info: () => (
  //         <Chip
  //           color="secondary"
  //           size="small"
  //           label="Updated"
  //         />
  //       )
  //     },
  //     {
  //       title: 'Calendar',
  //       href: '/app/calendar',
  //       icon: CalendarIcon,
  //       info: () => (
  //         <Chip
  //           color="secondary"
  //           size="small"
  //           label="Updated"
  //         />
  //       )
  //     }
  //   ]
  // },
  {
    subheader: 'Auth',
    items: [
      // {
      //   title: 'Login',
      //   href: '/login-unprotected',
      //   icon: LockIcon
      // },
      {
        title: 'Users',
        icon: UsersIcon,
        href: '/app/management/users',
        items: [
          {
            title: 'List Users',
            href: '/app/management/users'
          },
          {
            title: 'New User',
            href: '/app/management/users/new'
          }
          // {
          //   title: 'Edit Customer',
          //   href: '/app/management/customers/1/edit'
          // }
        ]
      }
      // {
      //   title: 'Register',
      //   href: '/register-unprotected',
      //   icon: UserPlusIcon
      // }
    ]
  }
  // {
  // subheader: 'Pages',
  // items: [
  //   {
  //     title: 'Account',
  //     href: '/app/account',
  //     icon: UserIcon
  //   },
  //   {
  //     title: 'Error',
  //     href: '/404',
  //     icon: AlertCircleIcon
  //   },
  //   {
  //     title: 'Pricing',
  //     href: '/pricing',
  //     icon: DollarSignIcon
  //   }
  // ]
  // },
  // {
  //   subheader: 'Extra',
  //   items: [
  //     {
  //       title: 'Charts',
  //       href: '/app/extra/charts',
  //       icon: BarChartIcon,
  //       items: [
  //         {
  //           title: 'Apex Charts',
  //           href: '/app/extra/charts/apex'
  //         }
  //       ]
  //     },
  //     {
  //       title: 'Forms',
  //       href: '/app/extra/forms',
  //       icon: EditIcon,
  //       items: [
  //         {
  //           title: 'Formik',
  //           href: '/app/extra/forms/formik'
  //         },
  //         {
  //           title: 'Redux Forms',
  //           href: '/app/extra/forms/redux'
  //         },
  //       ]
  //     },
  //     {
  //       title: 'Editors',
  //       href: '/app/extra/editors',
  //       icon: LayoutIcon,
  //       items: [
  //         {
  //           title: 'DraftJS Editor',
  //           href: '/app/extra/editors/draft-js'
  //         },
  //         {
  //           title: 'Quill Editor',
  //           href: '/app/extra/editors/quill'
  //         }
  //       ]
  //     }
  //   ]
  // }
];

function renderNavItems({ items, pathname, depth = 0 }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) => reduceChildRoutes({ acc, item, pathname, depth }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({ acc, pathname, item, depth }) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false
    });

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={Boolean(open)}
        title={item.title}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        key={key}
        title={item.title}
      />
    );
  }

  return acc;
}

const useStyles = makeStyles(() => ({
  mobileDrawer: {
    width: 256
  },
  desktopDrawer: {
    width: 256,
    top: 64,
    height: 'calc(100% - 64px)'
  },
  avatar: {
    cursor: 'pointer',
    width: 64,
    height: 64
  }
}));

const NavBar = ({ onMobileClose, openMobile }) => {
  const classes = useStyles();
  const location = useLocation();
  const { user } = useAuth();
  const dispatch = useDispatch();

  //console.log('branches', user.branches);

  const getSelectedBranchLocal = JSON.parse(localStorage.getItem('selBranch'));
  const [branches, setBranches] = useState(user.branches);
  const [branch, setABranch] = useState(getSelectedBranchLocal);

  const handleBranchSelection = value => {
    // e.preventDefault();
    if (value) {
      setABranch(value);
      localStorage.setItem('selBranch', JSON.stringify({
        branchId: value.branchId,
        branchName: value.branchName,
      }));
      const branchObject = {
        branchId: value.branchId,
        branchName: value.branchName,
      }
      // now set the global state.
      dispatch(setBranch(branchObject));
    }
  };

  useEffect(() => {
    console.log('branch',branch);

    if (!branch) {
      setABranch({branchId: user.branches[0].branchId, branchName: user.branches[0].branchName});
      localStorage.setItem('selBranch', JSON.stringify({
        branchId: user.branches[0].branchId,
        branchName: user.branches[0].branchName,
      }));
      const branchObject = {
        branchId: user.branches[0].branchId,
        branchName: user.branches[0].branchName,
      }
       // now set the global state.
      dispatch(setBranch(branchObject));

    }

    if (openMobile && onMobileClose) {
      onMobileClose();
    }

  }, [location.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Hidden lgUp>
          <Box p={2} display="flex" justifyContent="center">
            <Logo />
          </Box>
        </Hidden>
        <Box p={2}>
          <Box display="flex" justifyContent="center">
            <RouterLink to="/app/account">
              <Avatar alt="User" className={classes.avatar} src={user.avatar} />
            </RouterLink>
          </Box>
          <Box mt={2} textAlign="center">
            <Link
              component={RouterLink}
              to="/app/account"
              variant="h5"
              color="textPrimary"
              underline="none"
            >
              {user.name}
            </Link>
            <Typography variant="body2" color="textSecondary">
              Your tier:{' '}
              <Link component={RouterLink} to="/pricing">
                {user.tier}
              </Link>
            </Typography>
          </Box>
        </Box>
        <Divider />
        <Box p={2}>
         
            <Autocomplete
              value={branch}
              id="branchSelection"
              name="branchSelection"
              options={branches}
              getOptionLabel={option => option.branchName}
              getOptionSelected={(option, value) => option === value }
              // onBlur={(e, value) => {
              //   handleBranchSelection(value);
              // }}
              onChange={(e, value) => {
                handleBranchSelection(value);
              }}
              // renderOption={option => option}
              renderInput={params => (
                <TextField
                  {...params}
                  // label={branch ? branch : ''}
                  name="branchSelection"
                  margin="normal"
                  variant="outlined"
                  // placeholder="Select Vehicle Registration"
                  fullWidth
                />
              )}
            />
        </Box>
        <Divider />
        <Box p={2}>
          {sections.map(section => (
            <List
              key={section.subheader}
              subheader={
                <ListSubheader disableGutters disableSticky>
                  {section.subheader}
                </ListSubheader>
              }
            >
              {renderNavItems({
                items: section.items,
                pathname: location.pathname
              })}
            </List>
          ))}
        </Box>
        <Divider />
        {/* <Box p={2}>
          <Box
            p={2}
            borderRadius="borderRadius"
            bgcolor="background.dark"
          >
            <Typography
              variant="h6"
              color="textPrimary"
            >
              Need Help?
            </Typography>
            <Link
              variant="subtitle1"
              color="secondary"
              component={RouterLink}
              to="/docs"
            >
              Check our docs
            </Link>
          </Box>
        </Box> */}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
